export const postBiz = async (payload: any) => {
  const res = await fetch('/biz', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  const json = await res.json();
  if (!res.ok || json.failure) throw new Error(json.em || json.message || 'Request failed');
  return json;
};

const rows = (json: any) => {
  const sd = json.sd || json.result?.sd || json.data?.sd;
  return Array.isArray(sd) ? sd : [];
};

export const addForecastBatch = (fyr:string, scc:string, fnm:string, wbm:any) =>
  postBiz({s:'bieforecastbatch', a:'add', fyr, scc, fnm, wbm});

export const saveForecastSheets = (rid:number, sht:any[]) =>
  postBiz({s:'bieforecastbatch', a:'savesheets', rid, sht});

export const saveForecastFacts = (rid:number, rcd:any[]) =>
  postBiz({s:'bieforecastbatch', a:'savefacts', rid, rcd});

export const fetchForecastBatches = async (fyr='', ist='') =>
  rows(await postBiz({s:'bieforecastbatch', a:'find', fyr:fyr || null, ist:ist || null, pgo:0, pgl:100}));

export const fetchForecastPayload = (rid:number, scc:string) =>
  postBiz({s:'bieforecastbatch', a:'payload', rid, scc});

export const pushForecastToBieImport = (scenarioCode:string, filename:string, records:any[]) =>
  postBiz({
    s:'bieimport',
    a:'manual',
    trk:null,
    soc:'FORECAST',
    scc:scenarioCode,
    rcd:records,
    fnm:filename,
    fdt:{},
    att:{},
    exi:{origin:'BIE Forecast Data Mart'},
    rmk:'Auto-generated from determinant forecast datasets',
  });

export const fetchForecastFacts = async (rid: number, dsc = '') =>
  rows(await postBiz({
    s: 'bieforecastfact',
    a: 'find',
    rid,
    dsc: dsc || null,
  }));